<template>
  <div id="app">
    <v-header></v-header>
    <keep-alive><router-view v-if="$route.meta.keepAlive" :key="$route.fullPath" class="body" /></keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath" class="body" />
    <v-footer></v-footer>
    <v-player></v-player>
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import Player from './components/Player'
export default {
  name: 'App',
  components:{
    'v-header':Header,
    'v-footer':Footer,
    'v-player':Player,
  }
}
</script>

<style scoped lang="scss">
.body{margin-top: 188px;overflow: hidden;}
@media screen and (max-width: 900px) {
  .body{margin-top: 1.14rem;}
}
</style>



// WEBPACK FOOTER //
// src/App.vue